import React from "react";
import { Link } from "react-router-dom";

import { helperService } from "src/services/helper.service";

import styles from "./MyClubs.module.scss";

interface ICapacityRow {
    club_id: string;
    club_name: string;
    logo_url?: string;
    state?: string;
    country?: string;
    capacities: string[];
}

const MyClubs: React.FC = () => {
    const clubs: ICapacityRow[] = helperService.getCapacities();

    if (clubs.length === 0) return null;

    return (
        <div className={styles.MyClubs}>
            <div className={styles.title}>My Clubs</div>
            <ul className={styles.list}>
                {clubs.slice(0, 5).map((club) => (
                    <li key={club.club_id} className={styles.item}>
                        <Link to={`/k/${club.club_id}`} className={styles.inner}>
                            <div className={styles.portrait}>
                                {club.logo_url ? (
                                    <img
                                        src={club.logo_url}
                                        alt={club.club_name}
                                        className={styles.portraitImage}
                                    />
                                ) : (
                                    <div className={styles.portraitFallback}>
                                        {club.club_name.charAt(0).toUpperCase()}
                                    </div>
                                )}
                            </div>
                            <div className={styles.content}>
                                <span className={styles.name}>{club.club_name}</span>
                                {(club.state || club.country) && (
                                    <span className={styles.location}>
                                        {[club.state, club.country].filter(Boolean).join(", ")}
                                    </span>
                                )}
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
            <div className={styles.viewAll}>
                <Link to="/account?t=3">View All Clubs →</Link>
            </div>
        </div>
    );
};

export default MyClubs;
